const BO_URL = process.env.VUE_APP_API_BASE + '/bo/v1/';


// import store from '../store';
import { instance } from './index.js'
import API from './index.js'
import store from '../store';


const savePageContent = async (page, type) => {
    try {
        const response = await API.instance.post(`${BO_URL}save-page`, {
            structure: JSON.stringify(page.structure),
            content: page.content,
            type
        });
        return response;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error saving terms', type: 'error'})
        throw new Error(error);

    }
}

const getRoles = async () => {
    try {
        const response = await API.instance.get(`${BO_URL}get-roles`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading roles', type: 'error'})
        throw new Error(error);
    }
}

const getUsageData = async (startDate,endDate) => {
    try {
        const response = await API.instance.get(`${BO_URL}get-usage-info?startDate=${startDate}&endDate=${endDate}`);
        return response;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading usage data', type: 'error'})
        throw new Error(error);

    }
}
const getPendingAgreements = async () => {
    try {
        const response = await API.instance.get(`${BO_URL}pending-agreements`);
        if (response.data.ok) {
            store.dispatch('setValue', {key: 'pendingAgreements', value: response.data.agreements})
        }
        return response;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading pending agreements data', type: 'error'})
        throw new Error(error);

    }
}
const getUsers = async (startDate,endDate) => {
    try {
        const response = await API.instance.get(`${BO_URL}get-users`);
        return response;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading user data', type: 'error'})
        throw new Error(error);
    }
}

const createInvoice = async (data) => {
    try {
        const response = await API.instance.post(`${BO_URL}create-invoice`, data);
        return response;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error creating invoice', type: 'error'})
        throw new Error(error);
    }
}


const giveCredit = async ({user_id, amount}) => {
    try {
        let error_ = null;
        const response = await API.instance.post(`${BO_URL}give-credit`, {
            user_id,
            amount
        }).catch((error) => {
            if (error.response.status == 401) {
                error_ = {error: error.response.data.message};
            }
        });
        if (error_) {
            return error_;
        }
        store.dispatch('addNotification', {text: 'Credit added', type: 'success'})

        return response;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error during Credit addition', type: 'error'})
        throw new Error(error);
    }
}
const ActivateSubscription = async ({user_id}) => {
    try {
        let error_ = null;
        const response = await API.instance.post(`${BO_URL}activate-subscription`, {
            user_id,
        }).catch((error) => {
            if (error.response.status == 401) {
                error_ = {error: error.response.data.message};
            }
        });
        if (error_) {
            return error_;
        }
        store.dispatch('addNotification', {text: 'Subsription activated', type: 'success'})

        return response;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error during Subsription activation ', type: 'error'})
        throw new Error(error);
    }
}
const getPlatformControl = async () => {
    try {
        let error_ = null;
        const response = await API.instance.get(`${BO_URL}get-platform-control`).catch((error) => {
            if (error.response.status == 401) {
                error_ = {error: error.response.data.message};
            }
        });
        if (error_) {
            return error_;
        }
        
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading platrofm control ', type: 'error'})
        throw new Error(error);
    }
}

const updatePlatformControl = async (object) => {
    try {
        let error_ = null;
        const response = await API.instance.post(`${BO_URL}set-platform-control`, {
            ...object
        }).catch((error) => {
            if (error.response.status == 401) {
                error_ = {error: error.response.data.message};
                store.dispatch('addNotification', {text: 'Error updating platrofm control ', type: 'error'})
            }
        });
        if (error_) {
            return error_;
        }
        return response;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error updating platrofm control ', type: 'error'})
        throw new Error(error);
    }
}

const updateClientAccount = async (user_id, data) => {
    try {
        const response = await API.instance.post(`${BO_URL}update-client-account/${user_id}`, data).catch((error) => {
            console.log(error)
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error updating client account.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        console.log(error)
        store.dispatch('addNotification', {type: 'error', text: 'There was an error updating client account.\nPlease try again or contact the support'});
        return false
    }
}
const loadTemplates = async () => {
    try {
        const response = await API.instance.get(`${BO_URL}fiutemplates/list`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading templates', type: 'error'})
        throw new Error(error);
    }
}

const uploadTemplateFile = async (file, metadata) => {
    console.log('uploadTemplateFile', file, metadata)
    const response = await API.uploadFileGeneral(file, 'upload-template-file', metadata)
    return response;
}

const getRates = async () => {
    try {
        const response = await API.instance.get(`${BO_URL}currency-rates`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading rates', type: 'error'})
        throw new Error(error);
    }
}
const fetchRates = async (date) => {
    try {
        const response = await API.instance.post(`${BO_URL}fetch-rates`, {date});
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error fetching rates', type: 'error'})
        throw new Error(error);
    }
}


const getLogsFiles = async () => {
    try {
        const response = await API.instance.get(`${BO_URL}get-logs-files`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading logs files', type: 'error'})
        throw new Error(error);
    }
}

const getLog = async (filename) => {
    try {
        const response = await API.instance.get(`${BO_URL}get-log/${filename}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading log file', type: 'error'})
        throw new Error(error);
    }
}


const confirmEmailVerification = async (account_id) => {
    try {
        const response = await API.instance.post(`${BO_URL}confirm-email-verification`, {account_id});
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error confirming email verification', type: 'error'})
        throw new Error(error);
    }
}


const removeFile = async (filename) => {
    try {
        const response = await API.instance.post(`${BO_URL}remove-file/${filename}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error removing file', type: 'error'})
        throw new Error(error);
    }
}
const markInvoiceAsPayed = async (invoice_id, date) => {
    try {
        const response = await API.instance.post(`${BO_URL}mark-invoice-as-payed`, {invoice_id, date});
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error marking invoice as payed', type: 'error'})
        throw new Error(error);
    }
}
const setTemplateAccess = async (account_id, template_type, access) => {
    try {
        const response = await API.instance.post(`${BO_URL}set-template-access`, {account_id, template_type, access});
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error setting template access', type: 'error'})
        throw new Error(error);
    }
}
const updateAgreementStatus = async (params) => {
    try {
        const response = await API.instance.post(`${BO_URL}update-agreement-status`, params);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error updating agreement status', type: 'error'})
        throw new Error(error);
    }
}

// --- Company users (back-office management of a client's users) ---

const boRequest = async (method, path, data, errorText) => {
    try {
        const response = await API.instance[method](`${BO_URL}${path}`, data);
        return response.data;
    } catch (error) {
        const text = error?.response?.data?.message || errorText;
        store.dispatch('addNotification', {text, type: 'error'})
        return null;
    }
}

const getCompanyUsers = (account_id) =>
    boRequest('get', `accounts/${account_id}/users`, undefined, 'Error loading company users');
const getCompanyUserDetails = (user_id) =>
    boRequest('get', `company-users/${user_id}`, undefined, 'Error loading user');
const getCompanyUserPermissions = (user_id) =>
    boRequest('get', `company-users/${user_id}/permissions`, undefined, 'Error loading permissions');
const updateCompanyUserPermission = (user_id, name, effect) =>
    boRequest('post', `company-users/${user_id}/permissions`, {name, effect}, 'Error updating permission');
const sendCompanyUserPasswordReset = (user_id) =>
    boRequest('post', `company-users/${user_id}/reset-password`, {}, 'Error sending password reset email');
const resetCompanyUserTwoFA = (user_id) =>
    boRequest('post', `company-users/${user_id}/reset-2fa`, {}, 'Error resetting 2FA');
const setCompanyUserTwoFARequired = (user_id, required) =>
    boRequest('post', `company-users/${user_id}/two-fa-required`, {required}, 'Error updating 2FA requirement');


export default {
    getCompanyUsers,
    getCompanyUserDetails,
    getCompanyUserPermissions,
    updateCompanyUserPermission,
    sendCompanyUserPasswordReset,
    resetCompanyUserTwoFA,
    setCompanyUserTwoFARequired,
    getUsageData,
    getUsers,
    getLog,
    giveCredit,
    ActivateSubscription,
    getPlatformControl,
    updatePlatformControl,
    savePageContent,
    updateClientAccount,
    createInvoice,
    loadTemplates,
    uploadTemplateFile,
    getRates,
    fetchRates,
    getLogsFiles,
    confirmEmailVerification,
    removeFile,
    markInvoiceAsPayed,
    setTemplateAccess,
    getPendingAgreements,
    updateAgreementStatus
}

